<!--
    校区管理-互动课件管理
    功能：展示互动课件管理的数据列表
    组件：旧版本
-->
<template>
  <div class="courseware_ai">
    <AppList
      ref="list"
      :list.sync="list"
      title=""
      api="/department">
      <AppSearch
        v-if="checkPermission('index')"
        slot="search"
        :order="{ type: 'id', name: 'desc'}"
        :search-arr="searchArr"/>
      <template v-if="checkPermission('index')" slot-scope="props">
        <el-table :data="props.listData">
          <el-table-column
            v-for="column in columns"
            v-if="!column.show"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :width="column.width"
            :formatter="column.formatter"
          />
          <el-table-column
            label="操作"
            width="80px"
            class="orgin-btn"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                @click="StatisticalClass(scope.row.id)"
              >预览</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </AppList>
  </div>
</template>

<script>
  export default {
    name: "CoursewareAI",
    data() {
      return {
        list: {}
      }
    },
    computed: {
      columns() {
        return [
          { prop: 'name', label: '课件名称' },
          { prop: 'name', label: '课件标题' },
          { prop: 'name', label: '课件目录' },
          { prop: 'name', label: '教学内容' },
          { prop: 'name', label: '创建人员' },
          { prop: 'name', label: '创建时间' },
          { prop: 'name', label: '更新时间' }
        ];
      },
      searchArr() {
        const column = [
          { prop: 'name', label: '课件名称' },
          { prop: 'phone', label: '课件标题' },
          { prop: 'phone', label: '创建人员' }
        ];
        return [
          { componentType: 'AppSearchColumn', searchType: column },
        ];
      },
      role() {
        return this.$store.state.user;
      },
    },
    methods: {
      // 权限
      checkPermission(key, text) {
        return this.$permissions(`system.department.${key}`, text);
      }
    }
  }
</script>

<style scoped lang="scss">
.courseware_ai {

}
</style>



// WEBPACK FOOTER //
// src/views/CoursewareAI/index.vue